<template lang="pug">
// Page content
md-theme(md-name='blue')
  // Title
  breadcrumbs(section='Partner integrations')
  md-layout(md-flex='100', md-align='center')
    md-layout(md-flex='60', md-flex-small='100')
      md-whiteframe.form-wrapper-frame(md-elevation='3')
        md-layout(md-flex='100')
          md-layout.test(md-flex='100', md-flex-small='100', md-vertical-align='center', md-align='center')
            .turn-off-google-info
              div
                h4 Want a Roku channel?
                span Roku developer
                a(target="_blank", rel="noopener noreferrer", href="https://developer.roku.com/") sign up
                p
                  span Rhebus TV can also run this for you,
                  a(target="_blank", rel="noopener noreferrer", href="mailto:info@rhebus.works?Subject=Roku%20Channel%20Dev") please get in touch
              div
                h4 Want an Amazon FireTV App?
                span  Amazon FireTV developer
                a(target="_blank", rel="noopener noreferrer", href="https://developer.amazon.com/apps-and-games/console/app/list") sign up
                p
                  span Rhebus TV can also run this for you,
                  a(target="_blank", rel="noopener noreferrer", href="mailto:info@rhebus.works?Subject=Amazon%20App%20Dev") please get in touch
              div
                h4 Want more users for your Roku Channel?
                a(target="_blank", rel="noopener noreferrer", href="https://admanager.roku.com/login") Roku User Acquisition
                p
                  span Rhebus TV can also run this for you,
                  a(target="_blank", rel="noopener noreferrer", href="mailto:info@rhebus.works?Subject=Roku%20UA") please get in touch
              div
                h4 Need subtitles or closed captions for your video?
                p
                  a(target="_blank", rel="noopener noreferrer", href="https://www.3playmedia.com") 3Play Media
                p
                  a(target="_blank", rel="noopener noreferrer", href="https://dotsub.com") Dotsub
                p
                  a(target="_blank", rel="noopener noreferrer", href="http://main.wgbh.org/wgbh/pages/mag/services/captioning") Media Access Group WGBH-TV
                p
                  a(target="_blank", rel="noopener noreferrer", href="https://rev.com") Rev
                p
                  a(target="_blank", rel="noopener noreferrer", href="http://www.subply.com") SubPly
                p
                  a(target="_blank", rel="noopener noreferrer", href="https://visualdatamedia.com") Visual Data Media
        div.imgContainer
          img(src="../../assets/img/RhebusTV_logo.jpg")
</template>

<script type='text/javascript'>
import { mapState } from 'vuex';
import accountService from '../../services/accountService';
import Breadcrumbs from '../../shared-components/Breadcrumbs';

export default {
  components: {
    Breadcrumbs
  },
  computed: mapState({
    useraccount: state => state.user.useraccount,
    siteuser: state => state.user.siteuser
  }),
  methods: {
    turnOffDFP(useraccount) {
      accountService.turnOffDFP(useraccount._id).then(() => {
        this.$store.dispatch('user/loadSiteuserAccount');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-wrapper-frame {
  padding: 10px;
  width: 80vw;
  margin: auto !important;
  margin-top: 20px !important;
  border-radius: 10px;
  box-shadow: 1px 1px 20px 5px rgba(0, 0, 0, 0.2);
}

.test {
  display: block;
}
.test div{
  margin-bottom: 60px;
  line-height: 10px;
}
.turn-off-google-info {
  margin-left: 20px;
  font-size: 1.3em;

  @media (max-width: 1106px) {
    font-size: 1.1em;
  }
}

h4 {
  text-transform: uppercase;
}

.imgContainer {
  display: flex;
  justify-content: end;

}

.imgContainer img {
  margin-right: 20px;
  width: 250px;

  @media (max-width: 1106px) {
    width: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/partnerIntegrations/Profile.vue